import { BrowserRouter, Route, Routes } from "react-router";
import { Toast } from "./components/Toast";
import { Home } from "./pages/Home";
import { LobbyRoute } from "./pages/LobbyRoute";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/:code" element={<LobbyRoute />} />
      </Routes>
      <Toast />
    </BrowserRouter>
  );
}
